'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
};
module.exports = exports['default'];
//# sourceMappingURL=focus-fieldset.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/supports/focus-fieldset.js
// module id = 74
// module chunks = 0